"use client";

import { Trans } from "@lingui/react/macro";

export const VehicleSelectionLimitMessage = ({
	maxVehicles,
	selectedCount,
}: {
	maxVehicles: number;
	selectedCount: number;
}) => {
	if (selectedCount === 0) {
		return (
			<Trans comment="Heading above the vehicle list when editing a multi-vehicle permit and nothing is selected yet">
				Select up to {maxVehicles} vehicles for this permit
			</Trans>
		);
	}
	if (selectedCount >= maxVehicles) {
		return (
			<Trans comment="Heading above the vehicle list when editing a multi-vehicle permit and the limit is reached, so the remaining vehicles are disabled">
				<b>Max of {maxVehicles} selected.</b> Deselect one to change.
			</Trans>
		);
	}
	const remainingCount = maxVehicles - selectedCount;
	return (
		<Trans comment="Heading above the vehicle list when editing a multi-vehicle permit with some vehicles selected and room for more">
			{selectedCount} selected. You can add {remainingCount} more.
		</Trans>
	);
};
